import { render, staticRenderFns } from "./CustomRegisterContainer.vue?vue&type=template&id=f807018e&scoped=true"
import script from "./CustomRegisterContainer.vue?vue&type=script&lang=js"
export * from "./CustomRegisterContainer.vue?vue&type=script&lang=js"
import style0 from "./CustomRegisterContainer.vue?vue&type=style&index=0&id=f807018e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f807018e",
  null
  
)

export default component.exports